import {getDicts} from "../../api/system/dict/data";

// 跟据dictMap中的字典type获取并返回
export function getDictMap(dictMap) {
  return getDicts(Object.keys(dictMap)).then(data => {
    return Object.keys(dictMap).reduce((acc, dictType) => {
      acc[dictType] = data[dictType].reduce((map, {dictLabel, dictValue}) => {
          map[dictValue] = dictLabel;
          return map;
        },
        {}
      );
      return acc;
    }, {});
  });
}
